import VALUES from 'core/data-model/constants/values'

// ==== action types ====

export const CALCULATE_LSTU_TOTAL_FUND_ALLOCATION = 'INVESTMENT/CALCULATE_LSTU_TOTAL_FUND_ALLOCATION'

export const calculateLstuTotalLstuFundAllocation = (code, fundAllocation) => {
  return {
    type: CALCULATE_LSTU_TOTAL_FUND_ALLOCATION,
    payload: {
      code,
      fundAllocation,
    },
  }
}

export const UPDATE_LSTU_FUND_ALLOCATIONS = 'INVESTMENT/UPDATE_LSTU_FUND_ALLOCATIONS'

export const updateLstuFundAllocation = (lstuFunds) => {
  return {
    type: UPDATE_LSTU_FUND_ALLOCATIONS,
    payload: lstuFunds,
  }
}

export const UPDATE_LSTU_TOTAL_FUND_ALLOCATION = 'INVESTMENT/UPDATE_LSTU_TOTAL_FUND_ALLOCATION'

export const updateLstuTotalFundAllocation = (totalFundAllocation) => {
  return {
    type: UPDATE_LSTU_TOTAL_FUND_ALLOCATION,
    payload: totalFundAllocation,
  }
}

export const TOGGLE_LSTU_FUND_ALLOCATION = 'INVESTMENT/TOGGLE_LSTU_FUND_ALLOCATION'

export const toggleLstuFundAllocation = (fund) => {
  return {
    type: TOGGLE_LSTU_FUND_ALLOCATION,
    payload: fund,
  }
}

export const ALLOCATE_LSTU_SAME_AS_RPP = 'INVESTMENT/ALLOCATE_LSTU_SAME_AS_RPP'

export const allocateLstuSameAsRpp = () => {
  return {
    type: ALLOCATE_LSTU_SAME_AS_RPP,
    payload: VALUES.LSTU_FUND_ALLOCATION_OPTION.SAME_AS_RPP,
  }
}

export const ALLOCATE_LSTU_INDEPENDENTLY = 'INVESTMENT/ALLOCATE_LSTU_INDEPENDENTLY'

export const allocateLstuIndependently = () => {
  return {
    type: ALLOCATE_LSTU_INDEPENDENTLY,
    payload: VALUES.LSTU_FUND_ALLOCATION_OPTION.INDEPENDENT,
  }
}

export const RESET_LSTU_FUND_ALLOCATION = 'INVESTMENT/RESET_LSTU_FUND_ALLOCATION'
export const resetLstuFundAllocations = () => {
  return {
    type: RESET_LSTU_FUND_ALLOCATION,
  }
}

export const LSTU_ACCEPT_HIGHER_RISK_INVESTMENT = 'LSTU_ACCEPT_HIGHER_RISK_INVESTMENT'

export const lstuAcceptHigherRiskInvestment = () => ({
  type: LSTU_ACCEPT_HIGHER_RISK_INVESTMENT,
})

export const ANSWER_QUESTION_TO_ACCEPT_LSTU_FOREIGN_INVESTMENT = 'ANSWER_QUESTION_TO_ACCEPT_LSTU_FOREIGN_INVESTMENT'

export const LSTU_ACCEPT_FOREIGN_INVESTMENT = 'LSTU_ACCEPT_FOREIGN_INVESTMENT'

export const lstuAcceptForeignInvestment = () => ({
  type: LSTU_ACCEPT_FOREIGN_INVESTMENT,
})

export const answerQuestionToAcceptLstuForeignInvestment = (isAccept) => ({
  type: ANSWER_QUESTION_TO_ACCEPT_LSTU_FOREIGN_INVESTMENT,
  payload: isAccept,
})

export const UPDATE_LSTU_ACCEPT_FUND_ALLOCATION = 'INVESTMENT/UPDATE_LSTU_ACCEPT_FUND_ALLOCATION'

export const RESET_LSTU_FUND_CONSENTS = 'INVESTMENT/RESET_LSTU_FUND_CONSENTS'

export const resetLstuFundConsents = () => ({
  type: RESET_LSTU_FUND_CONSENTS,
})

export const RESET_LSTU_ACCEPT_FUND_ALLOCATION = 'INVESTMENT/RESET_LSTU_ACCEPT_FUND_ALLOCATION'

export const resetLstuAcceptFundAllocation = () => {
  return {
    type: RESET_LSTU_ACCEPT_FUND_ALLOCATION,
  }
}

export const updateLstuAcceptFundAllocation = (acceptFundAllocation) => {
  return {
    type: UPDATE_LSTU_ACCEPT_FUND_ALLOCATION,
    payload: acceptFundAllocation,
  }
}

export const acceptFundAllocation = () => {
  return {
    type: UPDATE_LSTU_ACCEPT_FUND_ALLOCATION,
    payload: true,
  }
}
